<template>
<div id="modalBodyScroll">
   <table id="modalBodyTable">
    <tbody>
      <tr>
        <td>Controlled Intersection</td>
        <td>
          <select v-model="crosswalk.atControlledIntersection">
            <option disabled value="">Select</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Crosses Major Street</td>
        <td>
          <select v-model="crosswalk.crossesMajorStreet">
            <option disabled value="">Select</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Speed Limit (MPH)</td>
        <td>
          <input
            v-model="crosswalk.speedLimit"
            minlength="2"
            maxlength="2"
            id="speedLimitInput"
          />
        </td>
      </tr>
      <tr>
        <td>Crosswalk Signage</td>
        <td>
          <select v-model="crosswalk.crosswalkSignage">
            <option disabled value="">Select</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Tactile Indicators</td>
        <td>
          <select v-model="crosswalk.tactileIndicators">
            <option disabled value="">Select</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>School Zone</td>
        <td>
          <select v-model="crosswalk.schoolZone">
            <option disabled value="">Select</option>
            <option>Yes</option>
            <option>No</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Risk Assessment</td>
        <td>
          <select v-model="crosswalk.riskLevel">
            <option disabled value="">Select</option>
            <option>1</option>
            <option>2</option>
            <option>3</option>
          </select>
        </td>
      </tr>
    </tbody>
  </table>
  <div id="notesSection">
    <div id="notesHeader">Notes</div>
    <div id="notesText">
      <textarea
        id="notesTextArea"
        v-model="crosswalk.notes"
        placeholder="add notes here">
      </textarea>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    crosswalk: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>

#notesTextArea {
  font-size: 16px;
  width: 100%;
}

#speedLimitInput {
  width: 52px;
}

input {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
